<template>
  <b-row>
    <b-col>
      <b-card title="Reportes" v-if="proccess.length" :class="[dark ? 'dark-mode-page' : '']" >
        <b-row>
          <b-col>
            <input type="checkbox" v-model="show" />
            {{ show ? "Ocultar menú" : "Ver" }}
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3" v-show="show">
            <VJstree
              id="admin-tree-information"
              ref="tree"
              multiple
              allow-batch
              draggable
              class="mt-5 mb-3 main-tree-default-vue"
              :class="[dark ? ' azul-rey' : '']"
              :data="proccess"
              show-checkbox
              @item-click="itemClick"
            >
              <!-- <template slot-scope="_">
            <div
              style="display: inherit; width: 200px"
              v-on:contextmenu="openMenu"
              v-if="_.model.slug == 'brigadas_disponibles_all'"
              @click.right="
                indexDataMenu = 0;
                current = _.model;
              "
            >
              <i
                :class="_.vm.themeIconClasses"
                role="presentation"
                v-if="!_.model.loading"
              ></i>
              <span v-html="_.model.text"></span>
              <button
                style="
                  border: 0px;
                  background-color: transparent;
                  cursor: pointer;
                "
                @click="customItemClick(_.vm, _.model, $event)"
              >
                <i class="fa fa-remove"></i>
              </button>
            </div>
          </template> -->
            </VJstree>
          </b-col>
          <b-col :md="!show ? 12 : 9" class="container-report p-3">
            <router-view></router-view>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Reportes" v-else :class="[dark ? 'dark-mode-page' : '']" >
          <b-row>
            <b-col class="text-center">
              <img src="assets/img/empty.png" alt="Empty" />
              <p :class="[dark ? 'text-white': '']" >No tiene ningún permiso para reportes</p>
            </b-col>
          </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import VJstree from "vue-jstree";
import toastr from "toastr";
import can from "@/permission";
import node from "./js/contain";
import { mapGetters } from "vuex";
export default {
  components: {
    VJstree,
  },
  mounted() {
    this.proccess = [];
    node.map((el) => {
      if (this.can(el.permission)) {
        this.proccess.push(el);
      }
    });
  },
  data() {
    return {
      proccess: [],
      show: true,
    };
  },
  computed: {
    ...mapGetters({
      dark: "mode/getTheme",
    }),
  },
  methods: {
    can: can,
    itemClick(node) {
      this.proccess.map((el) => {
        el.selected = false;
      });
      node.model.selected = true;
      if (node.model.name === "NavigateSipremReportBI") {
        this.onReportBI();
      } else if (this.$route.name != node.model.name) {
        this.$router.push({ name: node.model.name });
      }
    },
    async onReportBI(){
      try {
        window.open(
          `https://sgo-gd.sipremsol.co/`,
          // `http://165.227.218.137:832/?user=${response.data.usuario}`,
          '_blank',             
        );
        toastr.success("conexion establecida para SIPREM REPORTES BI");
      } catch (error) {
        toastr.warning("No se pudo ir a SIPREM REPORTES BI");
        console.log(error);        
      }
    }
  },
};
</script>
<style>
.container-report {
  border: 1px solid;
  border-color: rgba(51, 51, 51, 0.4);
}

body.dark-mode-page .azul-rey {
  color: #264ef8 !important;
}
</style>
